import React from 'react';
import { useLocation } from 'react-router-dom';
import MaintenancePage from '../Layout/MaintenancePage';

interface MaintenanceWrapperProps {
  showMaintenance?: boolean;
  children?: React.ReactNode;
}

const MaintenanceWrapper: React.FC<MaintenanceWrapperProps> = ({
  showMaintenance,
  children
}) => {
  const location = useLocation();

  // If maintenance mode is ON → Block all routes except login
  if (showMaintenance && location.pathname === '/') {
    return <MaintenancePage />;
  }

  return <>{children}</>;
};

export default MaintenanceWrapper;
